export default __webpack_public_path__ + "static/media/carIcon.f868855d.svg";